import React, { useState } from 'react';
import SavedCards from './SavedCards';
import { useAuth } from '../context/AuthContext';
import './ProfilePaymentMethods.css';

/**
 * ProfilePaymentMethods Component
 * 
 * A compact payment methods section designed to be integrated
 * into an existing profile page.
 */
const ProfilePaymentMethods = () => {
  useAuth();
  const [isExpanded, setIsExpanded] = useState(false);
  const [cardCount, setCardCount] = useState(0);

  // Handle expansion toggle
  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  // Update card count when cards are loaded
  const handleCardsLoaded = (cards) => {
    setCardCount(cards.length);
  };

  return (
    <div className="profile-payment-methods">
      <div className="payment-methods-header" onClick={handleToggle}>
        <div className="header-content">
          <div className="header-icon">💳</div>
          <div className="header-info">
            <h3>Payment Methods</h3>
            <p>{cardCount} saved card{cardCount !== 1 ? 's' : ''}</p>
          </div>
        </div>
        <div className="header-actions">
          <button className="expand-button">
            {isExpanded ? '−' : '+'}
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className="payment-methods-content">
          <SavedCards onCardsLoaded={handleCardsLoaded} />
        </div>
      )}
    </div>
  );
};

export default ProfilePaymentMethods; 